import type { ReactNode } from "react";
import { cn } from "./cn";

export interface TableProps {
  caption?: string;
  compact?: boolean;
  children: ReactNode;
}

/**
 * Semantic <table> with the shared density/scroll contract. Sorting and
 * pagination are the caller's responsibility — only wire them up when the
 * underlying API actually supports it.
 */
export function Table({ caption, compact, children }: TableProps) {
  return (
    <div className="ui-table-wrap">
      <table className={cn("ui-table", compact && "compact")}>
        {caption ? <caption className="sr-only">{caption}</caption> : null}
        {children}
      </table>
    </div>
  );
}
